import styles from './LinkSelect.less';

import React, { Component, PropTypes } from 'react';
import { ChevronIcon } from 'seek-style-guide/react';

import QualifiedLink from 'QualifiedLink/QualifiedLink';

export default class LinkSelect extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      refineParams: PropTypes.object
    })).isRequired,
    onChange: PropTypes.func
  };

  constructor() {
    super();

    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.valueChanged = this.valueChanged.bind(this);
    this.storeCheckboxReference = this.storeCheckboxReference.bind(this);
  }

  storeCheckboxReference(checkbox) {
    if (checkbox !== null) {
      this.checkbox = checkbox;
    }
  }

  toggleCheckbox() {
    this.checkbox.checked = !this.checkbox.checked;
  }

  valueChanged() {
    if (this.props.onChange) {
      this.props.onChange();
    }
    this.toggleCheckbox();
  }

  renderSingleOption({ label, activeLabel }) {
    return (
      <span className={`${styles.label} ${styles.label_isInactive}`}>
        { `${label} `}
        <strong className={styles.strong}>{ activeLabel }</strong>
      </span>
    );
  }

  renderMultiOptions({ id, label, options, activeLabel }) {
    return (
      <span>
        <input type="checkbox" id={id} className={styles.checkbox} ref={this.storeCheckboxReference} />
        <label htmlFor={id} className={styles.label}>
          { `${label} `}
          <strong className={styles.strong}>{ `${activeLabel} ` }</strong>
          <ChevronIcon direction="down" svgClassName={styles.chevronSvg} />
        </label>
        <label htmlFor={id} className={styles.backdrop}>Done</label>
        <ul className={styles.options}>
          {
            options.map(({ value, label: optionLabel, refineParams }) => (
              <li key={value}>
                {
                  refineParams ?
                    <QualifiedLink
                      className={styles.option}
                      path="/jobs"
                      params={refineParams}
                      onClick={this.valueChanged}>
                      { optionLabel }
                    </QualifiedLink> :
                    <span
                      className={styles.option}
                      onClick={this.toggleCheckbox}>
                      { optionLabel }
                    </span>
                }
              </li>
            ))
          }
        </ul>
      </span>
    );
  }

  render() {
    const { id, label, options } = this.props;
    const activeLabel = options.filter(option => option.isActive)[0].label.toLowerCase();

    return (
      <span className={styles.root}>
        {
          options.length === 1 ?
            this.renderSingleOption({ label, activeLabel }) :
            this.renderMultiOptions({ id, label, options, activeLabel })
        }
      </span>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultSummary/components/Filters/components/LinkSelect/LinkSelect.js
 **/